export default "__VITE_ASSET__C14J5nVA__"